/**
 * This file is autogenerated by:
 * /stencil-build-helpers/rollup/event-sync.ts
 */
export default {
  prevNextClicked: 'paf-result-timetable-list_prev-next-clicked',
};
